import styled from 'styled-components';

import { GreyInfoIcon } from '../../../../../../../assets';
import TextTooltip from '../../../../../../../components/TextTooltip';
import { ThemeProp } from '../../../../../../../theme/Themes';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
  width: 100%;
`;

export const SelectedOrgLabel = styled.span`
  color: ${(props: ThemeProp) => props.theme.colors.content.default};
  font-size: ${(props: ThemeProp) => props.theme.fontVariants.desktop.body2.fontSize};
  line-height: ${(props: ThemeProp) => props.theme.fontVariants.desktop.body2.lineHeight};
`;

export const SelectedFromOrgHeaderContainer = styled.div`
  display: flex;
  gap: 0.25rem;
`;

export const StyledTextTooltip = styled(TextTooltip).attrs((props) => {
  return {
    ...props,
    textAlign: 'left',
  };
})`
  .nextui-tooltip-button {
    margin-top: 2px !important;
  }
`;

export const StyledGreyInfoIcon = styled(GreyInfoIcon).attrs((props) => {
  return {
    fillBackground: props.theme.colors.neutrals.c200,
    fillLetter: props.theme.colors.neutrals.c400,
  };
})`
  margin-top: 2px;
`;
